import { requestJson } from './requestJson';

// With no testId: every test. With one: that test's reviewers.
// Neither shape contains reaction data (spec §5.1).
export async function getAdminTests(testId?: string): Promise<{
  tests?: {
    test_id: string;
    title: string | null;
    youtube_id: string;
    owner_email: string | null;
    created_at: string;
    expires_at: string | null;
    reviewer_count: number;
  }[];
  reviewers?: {
    reviewer_id: string;
    display_name: string | null;
    started_at: string;
    finished: boolean;
    reaction_count: number;
  }[];
}> {
  return await requestJson(
    testId ? `/api/admin/tests?test_id=${encodeURIComponent(testId)}` : '/api/admin/tests'
  );
}
